<template>
  <b-modal id="modal-challenge-delete" centered class="modal-challenge-delete" :no-enforce-focus="true">
    <div class="modal-challenge-delete-itens">
      <div class="modal-challenge-delete-itens-header">
        <button class="modal-challenge-delete-itens-close" @click="$bvModal.hide('modal-challenge-delete')">
          <div class="modal-challenge-delete-itens-close--icon">
            <img class="img-fluid" src="@/assets/img/close-modal.png" alt="icon close" title="icon close"/>
          </div>
        </button>
      </div>
      <div class="modal-challenge-delete-itens-body">
        <div class="modal-challenge-delete--header">
          <h2>Tem certeza que deseja excluir o Desafio?</h2>
        </div>
        <div class="modal-challenge-delete-btns">
          <button class="btn-green" @click="deleteChallenge(false)">
            Não
          </button>
          <button class="btn-yes" @click="deleteChallenge(true)">
            Sim
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('Tasks', ['editModalChallenge', 'challenges']),
  },
  methods: {
    ...mapActions('Tasks', ['removeChallengeTask']),
    async deleteChallenge(data) {
      if (!data) {
        this.$bvModal.hide('modal-challenge-delete');
        return;
      }
      let obj = { id_tc: this.editModalChallenge.id_tc, id_task: this.challenges.id_task };
      await this.removeChallengeTask({...obj});
      this.$bvModal.hide('modal-challenge-delete');
    }
  }
}
</script>

<style lang="scss">
#modal-challenge-delete {
	.modal-header, .modal-footer {
		display: none;
	}
	.modal-content {
		box-shadow: 0px 3px 16px rgba(0,0,0,0.16);
		border: 0;
    border-radius: 20px;
	}
	.modal-body {
		padding: 0;
	}
}
.modal-challenge-delete {
	&-itens {
		&-close {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 10px;
      border: 0;
      background: 0;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.8;
      }
		}
    &-body {
      padding: 25px 20px 30px 20px;
      .modal-challenge-delete {
        &--header {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          text-align: center;
          margin-bottom: 30px;
          h2 {
            font-size: 20px;
            font-family: 'Font Semibold';
            color: var(--black);

            margin-bottom: 0;
          }
        }
        &-btns {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 50px;
          .btn-green {
            width: calc(50% - 7.5px);
            padding: 0;
            margin: 0;
            transition: 500ms;
            &:hover,&:focus {
              cursor: pointer;
              opacity: 0.8;
            }
          }
          .btn-yes {
            width: calc(50% - 7.5px);
            height: 50px;
            background: var(--white);
            border: 1px solid var(--gray-1);
            border-radius: 30px;
            font-size: 20px;
            font-family: 'Font Bold';
            color: var(--gray-2);
            text-transform: uppercase;
            padding: 0;
            transition: 500ms;
            &:hover,&:focus {
              cursor: pointer;
              opacity: 0.8;
            }
          }
        }
      }
    }
	}
}
</style>
